import { Alert, AlertTitle, Box, Button, LinearProgress, Typography } from "@mui/material";
import { Link } from "react-router-dom";

import { CampaignMonitorResponse, MonitorSource } from "./monitor.types";
import { contractStateText, destinationErrorCount } from "./monitor.utils";
import { ProgressReportButton } from "./ProgressReportButton";

export function MonitorTop({ data, source }: { data: CampaignMonitorResponse; source: MonitorSource }) {
  const { top } = data;
  const many = data.contracts.length > 1;
  const unread = data.contracts.filter((c) => c.unreadable);
  /** invariant: o `top` do backend exclui os contratos não lidos; com algum deles, número nenhum sai sem a ressalva. */
  const scope = unread.length ? " nos contratos lidos" : "";
  const allUnread = unread.length > 0 && unread.length === data.contracts.length;
  const destinationErrors = destinationErrorCount(data);
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <ProgressReportButton source={source} type={data.type} />
      {data.contracts.map((c) => {
        const s = contractStateText(c);
        return (
          <Alert
            key={c.workspaceId}
            severity={s.alert ? "warning" : "info"}
            action={c.typeState.kind === "NO_LIFECYCLE" ? (
              <Button size="small" component={Link} to={`/v2/workspaces/${c.workspaceId}/edit`}>Abrir configuração do contrato</Button>
            ) : undefined}
          >
            {`${many ? `${c.label}: ` : ""}${s.text}`}
          </Alert>
        );
      })}
      {unread.length > 0 && (
        <Alert severity="warning">
          <AlertTitle>{`Dados de ${unread.length} contrato(s) não lidos`}</AlertTitle>
          {unread.map((c) => (
            <Typography key={c.workspaceId} variant="body2">{`${c.label}: ${c.unreadable}`}</Typography>
          ))}
        </Alert>
      )}
      {!allUnread && (
        <>
          <Typography variant="h6">{`Titulares resolvidos ${top.titulares.resolved} de ${top.titulares.total} (${top.titulares.percent}%)${scope}`}</Typography>
          <LinearProgress variant="determinate" value={top.titulares.percent} aria-label="Titulares resolvidos" />
          <Typography variant="body2">{`${top.vidas.total} vidas, ${top.vidas.decided} decididas${scope}`}</Typography>
          <Typography variant="body2">
            {`Aguardando${scope}: ${top.waiting}${top.oldestWaitingDays !== null ? ` · mais antiga há ${top.oldestWaitingDays} dias` : ""}`}
          </Typography>
          <Typography variant="body2">{`Sem canal: ${top.withoutChannel} · Falhas de envio: ${top.sendFailures}${scope}${destinationErrors ? ` · Destino não lido: ${destinationErrors} titular(es)` : ""}`}</Typography>
        </>
      )}
    </Box>
  );
}
